import React from 'react';
import PropTypes from 'prop-types';
import { CROSS_SIZE, PLUS_BORDER, PLUS_SIZE } from './constants';

const PlusIcon = ({ x, y }) => {
  return (
    <svg
      className="rt-project-route-substance-leaf-node-adornment__plus"
      width={PLUS_SIZE}
      height={PLUS_SIZE}
      x={x}
      y={y}
    >
      <circle
        className="rt-project-route-substance-leaf-node-adornment__plus-border"
        cx={PLUS_SIZE / 2}
        cy={PLUS_SIZE / 2}
        r={(PLUS_SIZE - PLUS_BORDER) / 2}
      >
      </circle>
      <svg
        className="rt-project-route-substance-leaf-node-adornment__plus-cross"
        width={CROSS_SIZE}
        height={CROSS_SIZE}
        x={(PLUS_SIZE - CROSS_SIZE) / 2}
        y={(PLUS_SIZE - CROSS_SIZE) / 2}
      >
        <use href="#icon-plus" />
      </svg>
    </svg>
  );
};

PlusIcon.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
};

export default PlusIcon;
